import React, { useState } from "react";
import { Link } from "react-router-dom";
import menu from "./menu.png";
import { AnimatePresence, delay, motion, useInView } from "framer-motion";

import close from "./close.png";
const Navbar = ({ textColor }) => {
  const navStyle = {
    color: textColor,
  };

  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav style={navStyle} data-header >
      <div
        className=" flex pt-5 px-5 lg:px-20  justify-between min-w-full  top-0 fixed z-[9999] bg-none navj  "
        id="nav"
      >
        <p className=" league-spartan-extrabold tracking-wider text-3xl">
          hemil .
        </p>
        <img
          src={menu}
          alt="menu"
          className=" h-4 sm:h-8 w-auto md:hidden"
          onClick={() => {
            setMenuOpen(!menuOpen);
          }}
        />
        <ul className=" hidden md:visible league-spartan-extrabold md:flex gap-3 md:pr-10 text-lg items-center">
          <li className="">
            {/* <Link to="/"> */}
            {/* Home */}
            {/* </Link> */}
            <a href="/">Home</a>
          </li>
          <li>
            <a href="/about">About</a>
          </li>
          <li>
            <a href="/projects">Projects</a>
          </li>
          <li>
            <a href="/contact">Contact </a>
          </li>
        </ul>
        {menuOpen && (
          
            <div className=" absolute min-h-screen flex bg-white w-full top-0 left-0 left  ">
              <img
                src={close}
                alt="menu"
                className=" absolute right-4 top-4 h-5"
                onClick={() => {
                  setMenuOpen(!menuOpen);
                }}
              />
              <ul className=" w-full flex flex-col justify-center items-center  league-spartan-extrabold md:flex gap-3 md:pr-10 text-lg ">
                <li className="">
                  <a href="/">Home</a>
                </li>
                <li>
                  <a href="/about">About</a>
                </li>
                <li>
                  <a href="/projects">Projects</a>
                </li>
                <li>
                  <a href="/about">Contact us</a>
                </li>
              </ul>
            </div>
        

        )}
      </div>
    </nav>
  );
};

export default Navbar;
